import type { TenantConfig } from '@/types/TenantConfig'

export const mtq: TenantConfig = {
  logo: 'assets/mtq/static/logo-white.png',
  themeOptions: {
    dialog: {
      headerBackground: '#EBEBEB',
    },
    mobileFooter: {
      textColor: '#333333',
      priceTextColor: '#333333',
    },
  },
  teaserImageSize: {
    width: 350,
    height: 350,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/mtq/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-160px',
        mobile: '-100px',
      },
    },
  },
}
